"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getFirstValidEmail_1 = require("./getFirstValidEmail");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return getFirstValidEmail_1.default; } });
//# sourceMappingURL=index.js.map